var map = {
	"./canton/ag.png": "08d7",
	"./canton/ai.png": "719e",
	"./canton/ar.png": "a026",
	"./canton/be.png": "8abf",
	"./canton/bl.png": "9f21",
	"./canton/bs.png": "072e",
	"./canton/fl.png": "df54",
	"./canton/fr.png": "2e9a",
	"./canton/ge.png": "3fcd",
	"./canton/gl.png": "76a0",
	"./canton/gr.png": "0870",
	"./canton/ju.png": "a362",
	"./canton/lu.png": "1c25",
	"./canton/ne.png": "9c9a",
	"./canton/nw.png": "c7406",
	"./canton/ow.png": "be70",
	"./canton/sg.png": "0e81",
	"./canton/sh.png": "f949",
	"./canton/so.png": "086d",
	"./canton/sz.png": "031d",
	"./canton/tg.png": "85b1",
	"./canton/ti.png": "5cec",
	"./canton/ur.png": "9cbc",
	"./canton/vd.png": "7c20",
	"./canton/vs.png": "fe02",
	"./canton/zg.png": "2579",
	"./canton/zh.png": "7e7b",
	"./error/alert.svg": "7f0dc",
	"./error/expired.png": "89f6",
	"./faq/chamber_definition.png": "926f",
	"./faq/quick_release_01.png": "1843",
	"./faq/quick_release_02.png": "06ca",
	"./faq/quick_release_03.png": "8bdf",
	"./icons/configuration.svg": "314a",
	"./icons/pages/403.svg": "0c9e",
	"./icons/pages/404.svg": "6feb",
	"./icons/pages/500.svg": "45ec",
	"./icons/pages/maintenance.svg": "6f3a",
	"./icons/pages/soon.svg": "9324",
	"./icons/pages/token.svg": "d849",
	"./icons/w-account-group.svg": "c66d",
	"./icons/w-account.svg": "af2a",
	"./icons/w-deregistration-bottles-status-check.svg": "aaaf",
	"./icons/w-deregistration-bottles-status-eye.svg": "c998",
	"./icons/w-deregistration-bottles-status-star.svg": "6cc1",
	"./icons/w-deregistration-compressor-status-check.svg": "c9f7",
	"./icons/w-deregistration-compressor-status-eye.svg": "82af",
	"./icons/w-deregistration-compressor-status-star.svg": "b903",
	"./icons/w-deregistration-pipes-status-check.svg": "a99d",
	"./icons/w-deregistration-pipes-status-eye.svg": "a528",
	"./icons/w-deregistration-pipes-status-star.svg": "2a50",
	"./icons/w-file-document-multiple-new.svg": "7502",
	"./icons/w-file-document-multiple-star.svg": "ef48",
	"./icons/w-file-document-multiple-warning.svg": "4425",
	"./icons/w-message-check.svg": "2e63",
	"./icons/w-message-eye.svg": "7fc6",
	"./icons/w-message-star.svg": "9f02",
	"./icons/w-message-warning.svg": "330d",
	"./icons/w-registration-bottles-status-check.svg": "8f70",
	"./icons/w-registration-bottles-status-deleted.svg": "465e",
	"./icons/w-registration-bottles-status-dialog.svg": "e4ab",
	"./icons/w-registration-bottles-status-edit.svg": "78c1",
	"./icons/w-registration-bottles-status-eye.svg": "77c2",
	"./icons/w-registration-bottles-status-shield.svg": "f9da",
	"./icons/w-registration-bottles-status-star.svg": "a95d",
	"./icons/w-registration-bottles-status-sync.svg": "d9ab",
	"./icons/w-registration-compressor-status-check.svg": "8fb7",
	"./icons/w-registration-compressor-status-deleted.svg": "1cb2",
	"./icons/w-registration-compressor-status-dialog.svg": "899d",
	"./icons/w-registration-compressor-status-edit.svg": "3066",
	"./icons/w-registration-compressor-status-eye.svg": "132db",
	"./icons/w-registration-compressor-status-shield.svg": "0fe2",
	"./icons/w-registration-compressor-status-star.svg": "3cf3",
	"./icons/w-registration-compressor-status-sync.svg": "32d4",
	"./icons/w-registration-pipes-status-check.svg": "06d7",
	"./icons/w-registration-pipes-status-deleted.svg": "c0cf",
	"./icons/w-registration-pipes-status-dialog.svg": "7a53",
	"./icons/w-registration-pipes-status-edit.svg": "77ab",
	"./icons/w-registration-pipes-status-eye.svg": "f5ae",
	"./icons/w-registration-pipes-status-shield.svg": "3611",
	"./icons/w-registration-pipes-status-star.svg": "d640",
	"./icons/w-registration-pipes-status-sync.svg": "3ae1",
	"./icons/w-task-transfer-to-system-check.svg": "bccb",
	"./icons/w-task-transfer-to-system-star.svg": "dbb3",
	"./icons/w-task-transfer-to-system-warning.svg": "4e9c",
	"./icons/w-task-transfer-to-system.svg": "acbe",
	"./suva-logo.png": "e8cc",
	"./svti-logo.svg": "949d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";